module.exports = __webpack_public_path__ + "static/b5-c5a18209d81576623847d09394a6c2aa.jpg";